<template>
  <div class="mb-4" v-if="esTicketInfo !== null">
    <template>
      <b-alert class="fixed-top-alert" :show="techInfoDuplicate" variant="danger">
        <b>Warning: </b>Duplicate values detected in the <b>Step 2: Technical Information</b> section. Please verify the accuracy of your input.
</b-alert>
    </template>

    <template>
      <b-breadcrumb :items="breadcrumbItems" style="font-size:14px"></b-breadcrumb>
    </template>
    <!--#region -- Content ---->
    <div class="stage-header border-bottom mb-4">
      <!-- v-if="basicInfo !== null"-->
      <!--#region Header-->
      <div class="caption-label">
        Basic Information
      </div>
      <div class="row mb-4">
        <div class="col-6">
          <div v-if="actionEnable" class="header-col">
            <div>Actions for Owner</div>
            <div v-if="esTicketInfo !== null">
              <div v-if="actionEnable">
                <b-button @click="showChangeOwnerModal" class="btn btn-primary btn-sm min-w-4" variant="primary">Change Ticket Owner</b-button>
                <b-button @click="showCloneEsModal" class="btn btn-primary btn-sm min-w-4" variant="primary">Clone Ticket</b-button>
              </div>
            </div>
          </div>
          <div class="header-col">
            <div>Salesforce ES</div>
            <div v-if="esTicketInfo !== null">
              <gtc-account-link v-if="_.get(esTicketInfo, 'opty_obj_id', null) != null"
                               :opportunityId="_.get(esTicketInfo, 'opty_obj_id', null)"
                               :opportunityName="esId" />
            </div>
          </div>
          <div class="header-col">
            <div>ES Status</div>
            <div v-if="esTicketInfo !== null">

              <!--{{_.get(esTicketInfo, 'es_ticket_status', 'Not Processed Yet')}}-->
              <b-form-select v-model="esTicketInfo.es_ticket_status"
                             :options="statusOptions"
                             label="status"></b-form-select>
            </div>
          </div>
          <div class="header-col">
            <div>ES Creator</div>
            <div v-if="esTicketInfo !== null">

              {{ _.get(esTicketInfo, 'es_ticket_create_by', null) }}
              <!--{{_.get(esTicketInfo, 'es_ticket_status', 'Not Processed Yet')}}-->
            </div>
          </div>
        </div>
        <div class="col-6">
          <div v-if="checkAssignerPermission()" class="header-col">
            <div>Actions for Admin</div>
            <div v-if="esTicketInfo !== null">
              <div v-if="checkAssignerPermission()">
                <b-button @click="showAssignTicketModal" class="btn btn-primary btn-sm min-w-4" variant="primary">Assign Ticket</b-button>
              </div>
            </div>
          </div>
          <div class="header-col">
            <div>FTIE ID</div>
            <!--             <gtc-ftie :ftieId="ftieId" /> -->


            <a class="link" target="_blank"
               :href="safeUrl(`${ frontEndUrlToUse }ftie/ftie-page/${ ftieId }`)">
              {{ ftieId }}
            </a>


          </div>
          <div class="header-col">
            <div>Close Reason</div>
            <textarea class="w-100" v-if="esTicketInfo !== null" :disabled="closeReasonReadOnly" v-model="esTicketInfo.close_reason"></textarea>
          </div>
          <div :class="[classObject(_.get(esTicketInfo, 'close_reason', ''), 255)]" style="padding-left: 162px;">
            <span>You've input: {{ _.get(esTicketInfo, 'close_reason', '') | getInputLength }}/255</span>
          </div>
        </div>

      </div>
    </div>

    <!--#endregion Header-->
    <div>
      <!-- #region: step one:  Primary Inforamtion-->

      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-1
                      :variant="(!isShowingCollapseFunc('accordion-1') || !esFullPageEditbale) ? 'secondary' : 'primary'"
                      :class="(!isShowingCollapseFunc('accordion-1') || !esFullPageEditbale) ? 'text-dark' : 'text-white'"
                      style="text-align: left;">
              <b>
       <img src="../../../static/image/getac-icon-dash-dark.svg"
         style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon" />
                <!-- src="../../../static/image/getac-icon-dash.svg"-->
                Step 1: Primary Inforamtion
              </b>
              (Please complete the required fields and proceed to next step)
            </b-button>
          </b-card-header>
          <b-collapse v-if="isShowingCollapseFunc('accordion-1')"
                      :visible="visible"
                      id="accordion-1"
                      accordion="step-one"
                      role="tabpanel">
            <b-card-body>
              <b-card-text><b>Prerequisite Information I</b></b-card-text>
              <div class="row mb-4">
                <div class="col-10" style="margin-left: 20px;">

                  <div class="header-col">
                    <div style="margin: 5.5px;">RSM/BDM<span class="text-danger pl-1">*</span></div>
                    <div v-if="esFullPageEditbale">
                      <gtc-multi-select style="width: 35rem;" v-model="primaryInfoInputs.rsm" key-field="value" text-field="text" :multiple="false"
                                        :options="rsmOptions" select-class="w-100" @change="getOptions"></gtc-multi-select>
                    </div>
                    <div v-else-if="primaryInfoInputs.rsm == null" style="margin: 5.5px;">
                      {{missingData}}
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(primaryInfoInputs, 'rsm.value', '')}}
                    </div>
                  </div>

                  <div class="header-col">
                    <div style="margin: 5.5px;">
                      Account Name<span class="text-danger pl-1">*</span>
                    </div>
                    <div v-if="esFullPageEditbale">
                      <gtc-multi-select style="width: 35rem;" v-model="primaryInfoInputs.accountId" key-field="value" text-field="text" :multiple="false"
                                        :options="accountOptions" select-class="w-100" @change="onChangeByAccount"></gtc-multi-select>
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(esTicketInfo.primary_info, 'account_name', '')}}
                    </div>
                    <div v-if="esFullPageEditbale && primaryInfoInputs.accountId !== null" style="margin: 5.5px;">
                      <button type="button" class="btn btn-sm btn-primary"
                              @click="resetAccountOpty"
                              v-b-tooltip.hover.right
                              title="This will clean the chosen account and opportunity">
                        Reset
                      </button>
                    </div>

                  </div>

                  <div class="header-col">
                    <div style="margin: 5.5px;">Opportunity Name</div>
                    <div v-if="esFullPageEditbale">
                      <gtc-multi-select style="width: 35rem;" v-model="primaryInfoInputs.optyId" key-field="value" text-field="text" :multiple="false"
                                        :options="optyOptions" select-class="w-100" @change="onChangeByOpty"></gtc-multi-select>
                    </div>
                    <div v-else style="margin: 5.5px;">
                      <gtc-opportunity :opportunityId="esTicketInfo.opty_master_id"
                                       :opportunityName="esTicketInfo.opty_name" />

                    </div>
                    <div v-if="esFullPageEditbale && primaryInfoInputs.optyId !== null && primaryInfoInputs.accountId !== null" style="margin: 5.5px;">
                      <button type="button" class="btn btn-sm btn-primary"
                              @click="resetAccountOpty"
                              v-b-tooltip.hover.right
                              title="This will clean the chosen account and opportunity">
                        Reset
                      </button>
                    </div>

                  </div>
                </div>
              </div>
              <div class="border-bottom my-4"></div>
              <b-card-text>
                <b>Prerequisite Information II</b>
                <code v-if="esFullPageEditbale" style="margin-left: 10px;">{{ text }}</code>
              </b-card-text>
              <div class="row mb-4">
                <div class="col-10" style="margin-left: 20px;">
                  <div class="header-col-wider ">
                    <div style="margin: 5.5px;">Why you need this engineering service<span class="text-danger pl-1">*</span></div>
                    <div v-if="esFullPageEditbale">
                      <div v-if="sfdcInfoIsAllSet">
                        <b-form-select style="width: 70rem;"
                                       v-model="primaryInfoInputs.esPurpose"
                                       :options="whyNeedEsOptions"
                                       @change="onChangeIssueCategory"
                                       label="Request Type"></b-form-select>
                      </div>
                      <div v-else>
                        <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                                v-b-tooltip.hover.right
                                title="Please input above data first!"></button>
                      </div>
                    </div>
                    <div v-else-if="primaryInfoInputs.esPurpose == null" style="margin: 5.5px;">
                      {{missingData}}
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(primaryInfoInputs, 'esPurpose', '')}}
                    </div>
                  </div>

                  <div class="header-col-wider ">
                    <div style="margin: 5.5px;">What type of issue is matching question<span class="text-danger pl-1">*</span></div>
                    <div v-if="esFullPageEditbale">
                      <div v-if="sfdcInfoIsAllSet">
                        <b-form-select style="width: 70rem;"
                                       v-model="primaryInfoInputs.typeOfIssue"
                                       :options="typeOfIssueOptions"
                                       @change="updateAutopilotChoice"
                                       label="Type of Issue"></b-form-select>
                      </div>
                    </div>
                    <div v-else-if="primaryInfoInputs.typeOfIssue == null" style="margin: 5.5px;">
                      {{missingData}}
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(primaryInfoInputs, 'typeOfIssue', '')}}
                    </div>
                  </div>

                  <div class="header-col-wider ">
                    <div style="margin: 5.5px;">Requirement stage<span class="text-danger pl-1">*</span></div>
                    <div v-if="esFullPageEditbale">
                      <div v-if="sfdcInfoIsAllSet">
                        <b-form-select style="width: 70rem;"
                                       v-model="primaryInfoInputs.requirementStage"
                                       :options="requirementStageOptions"
                                       label="Requirement Stage"></b-form-select>
                      </div>
                    </div>
                    <div v-else-if="primaryInfoInputs.requirementStage == null " style="margin: 5.5px;">
                      {{missingData}}
                    </div>
                    <div v-else style="margin: 5.5px;">
                      {{_.get(primaryInfoInputs, 'requirementStage', '')}}
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->
      <!-- #region: step-two-->
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-2
                      :variant="(!isShowingCollapseFunc('accordion-2') || !esFullPageEditbale) ? 'secondary' : 'primary'"
                      :class="(!isShowingCollapseFunc('accordion-2') || !esFullPageEditbale) ? 'text-dark' : 'text-white'"
                      style="text-align: left;">
              <b>
                <img src="../../../static/image/getac-icon-dash-dark.svg"
                     style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon"/>
                Step 2: Technical Information
              </b>
              (Please complete the required fields and proceed to next step)
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-2" accordion="step-two" role="tabpanel">
            <!-- v-if="primaryInfoAllSet && isShowingCollapseFunc('accordion-2')" -->
            <b-card-body>
              <div class="row mb-4">
                <div class="col-6">

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Source in SFDC</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div style="margin: 5.5px;" v-if="esTicketInfo.ftie_id!==null">
                          {{ _.get(esTicketInfo, 'source', null) }}
                        </div>
                        <div v-else style="margin: 5.5px;">
                          {{ sfdc_source_mapping }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Request Type in SFDC</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div style="margin: 5.5px;" v-if="esTicketInfo.ftie_id!==null">
                          {{ _.get(esTicketInfo, 'request_type', null) }}
                        </div>
                        <div v-else style="margin: 5.5px;">
                          {{ sfdc_request_type_mapping }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Issue Type in SFDC</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div style="margin: 5.5px;" v-if="esTicketInfo.ftie_id!==null">
                          {{ _.get(esTicketInfo, 'issue_type', null) }}
                        </div>
                        <div v-else style="margin: 5.5px;">
                          {{ sfdc_issue_type_mapping }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Engineering Service Issue / Requirement</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.es_issue" :disabled="!esFullPageEditbale"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'es_issue', ''), 2000)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'es_issue', '') | getInputLength }}/2000</span>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Impact</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.impact" :disabled="!esFullPageEditbale"></textarea>
                          <div :class="[classObject(_.get(esTicketInfo.tech_info, 'impact', ''), 255)]">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'impact', '') | getInputLength }}/255</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">3rd-Party Applications</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'tech_info', null) !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.third_party_application" :disabled="!esFullPageEditbale"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'third_party_application', ''), 255)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'third_party_application', '') | getInputLength }}/255</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <img src="../../../static/image/gtc-vertical-line.svg" alt="Vertical Line" />
                  <!-- style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;"-->
                </div>


                <div class="col-6" style="margin-left: -7px;">
                  <div class="header-col-mid">
                    <div>Owner</div>
                    <div v-if="esTicketInfo !== null">{{ _.get(esTicketInfo, 'es_ticket_create_by', null) }}</div>
                  </div>
                  <div class="header-col-mid">
                    <div>Priority</div>
                    <div v-if="esTicketInfo !== null &&　_.get(esTicketInfo, 'tech_info', null) !== null">
                      <b-form-select style="width: 15rem;"
                                     v-model="esTicketInfo.tech_info.priority"
                                     :options="priority_options"
                                     label="Priority" :disabled="!esFullPageEditbale"></b-form-select>
                    </div>
                  </div>
                  <div class="header-col-mid">
                    <div>Due Date<span class="text-danger pl-1">*</span></div>
                    <div v-if="esTicketInfo !== null &&　_.get(esTicketInfo, 'tech_info', null) !== null">
                      <input style="width: 15rem;" v-datepicker:from="date_from" v-model="esTicketInfo.tech_info.due_date" :disabled="!esFullPageEditbale" />
                    </div>
                    <!--</div>-->
                  </div>
                  <div class="header-col-mid">
                    <div>Model<span class="text-danger pl-1">*</span></div>
                    <div v-if="esTicketInfo.ftie_id !=null">
                      {{esTicketInfo.tech_info.model}}
                    </div>
                    <div v-else>
                      <b-form-select style="width: 15rem;"
                                     v-model="esTicketInfo.tech_info.model"
                                     :options="_.get(primaryInfoInputs, 'modelList', null)"
                                     label="Model" :disabled="!esFullPageEditbale"></b-form-select>
                    </div>

                  </div>

                  <div class="header-col-mid">
                    <div>Configuration</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.configuration" :disabled="!esFullPageEditbale"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'configuration', ''), 1000)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'configuration', '') | getInputLength }}/1000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Detailed Spec</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null ">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.detailed_spec" :disabled="!esFullPageEditbale"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Customer Application / User Scenario</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null ">
                          <textarea class="w-100"
                                    style="height: 80px;"
                                    v-model="esTicketInfo.tech_info.user_scenario" :disabled="!esFullPageEditbale"></textarea>
                          <div :class="classObject(_.get(esTicketInfo.tech_info, 'user_scenario', ''), 1000)">
                            <span>You've input: {{ _.get(esTicketInfo.tech_info, 'user_scenario', '') | getInputLength }}/1000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>
                      Attachment
                      <div class="ml-3 mb-1 d-print-none">
                        <label class="btn btn-primary btn-sm">
                          <span>Upload</span>
                          <input type="file" class="d-none" v-on:change="uploadAttachment($event, esTicketInfo.opty_obj_id)" />
                        </label>
                      </div>
                    </div>
                    <div class="flex-fill">
                      <!--<div class="flex-wrap"> <span>test_file.pdf</span> </div>-->
                      <!--#region Reference Files-->
                      <!-- show uploaded files via table -->
                      <div>
                        <b-table small thead-class="thead-light text-dark" style="table-layout: fixed;"
                                 :items="attach_files" :fields="attachFileFields">
                          <template #cell(file_name)="data">
                            <a herf="#" class="file" @click="downloadSfEsAttachment(data.item.ATTACHMENT_ID, data.item.FILE_NAME)">{{data.item.FILE_NAME}}</a>
                          </template>
                          <!--
                        <template #cell(update_time)="data">
                              {{ data.item.update_time | dateTimeFormat }}
                            </template>
                        -->

                          <template #cell(delete)="data">
                            <button type="button" class="btn btn-link p-0 btn-svg gtc-icon-delete"
                                    @click="showDeleteAttachmentModal(data.item.ATTACHMENT_ID, data.item.FILE_NAME)"></button>
                          </template>
                        </b-table>
                      </div>
                      <!--#endregion-->
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->
      <!-- #region: step-three: additional info for customization -->
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-3
                      :variant="!isShowingCollapseFunc('accordion-3') ? 'secondary' : 'primary'"
                      :class="!isShowingCollapseFunc('accordion-3') ? 'text-dark' : 'text-white'"
                      style="text-align: left;">
              <b>
                <img src="../../../static/image/getac-icon-dash-dark.svg"
                     style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon"/>
                Additional Information for Customization
              </b>
              (Please complete the required fields if you request a customization)
            </b-button>
          </b-card-header>
          <!-- v-if="primaryInfoAllSet && isShowingCollapseFunc('accordion-3')"-->
          <b-collapse id="accordion-3" accordion="customization-info" role="tabpanel">
            <b-card-body>
              <div class="row mb-4">
                <div class="col-6">

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">Delivery Date of POC<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <input class="w-100" style="height: 35px;" v-datepicker:from="date_from" v-model="esTicketInfo.customization_info.poc_delivery_date" :disabled="!esFullPageEditbale" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div style="margin: 5.5px;">ECO System<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;" v-model="esTicketInfo.customization_info.eco_system" :disabled="!esFullPageEditbale"></textarea>
                          <div :class="[classObject(_.get(esTicketInfo.customization_info, 'eco_system', ''), 255)]">
                            <span>You've input: {{ _.get(esTicketInfo.customization_info, 'eco_system', '') | getInputLength }}/255</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div v-if="selectedAutopilot === 'Yes' ">
                  <img src="../../../static/image/gtc-vertical-line-sectsol.svg" alt="Sector Solution Vertical Line" />
                  <!--<img src="../../../static/image/gtc-vertical-line-customization.svg" />
                -->
                  <!-- style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;"-->
                </div>
                <div v-else>
                  <img src="../../../static/image/gtc-vertical-line-customization.svg" alt="Customization Vertical Line" />
                </div>


                <div class="col-6" style="margin-left: -7px;">
                  <div class="header-col-mid">
                    <div>Delivery Date of MP<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <input class="w-100" style="height: 35px;" v-datepicker:from="date_from" v-model="esTicketInfo.customization_info.mp_delivery_date" :disabled="!esFullPageEditbale" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="header-col-mid">
                    <div>Detailed Customization Request<span class="text-danger pl-1">*</span></div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'customization_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;" v-model="esTicketInfo.customization_info.customization_request" :disabled="!esFullPageEditbale"></textarea>
                          <div :class="[classObject(_.get(esTicketInfo.customization_info, 'customization_request', ''), 1000)]">
                            <span>You've input: {{ _.get(esTicketInfo.customization_info, 'customization_request', '') | getInputLength }}/1000</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- New Region for AutoPilot v-if="'Software - Autopilot' === self.esTicketInfo.primary_info.matching_issue"
                -->
                  <div class="header-col-mid" style="margin-top: 25px;">
                    <div>
                      Microsoft Autopilot
                      <span class="text-danger pl-1">*</span>
                    </div>
                    <div class="flex-fill">
                      <div class="row">
                        <div class="col">
                          <div>
                            Does this customization request include the MS Autopilot registration service
                            <span class="text-danger pl-1">*</span>
                          </div>
                          <div class="flex-fill">
                            <div class="flex-wrap" v-if="esTicketInfo !== null">
                              <b-form-group>
                                <!-- v-slot="{ ariaDescribedby }"  -->
                                <b-form-radio-group id="autopilot-radio-1"
                                                    v-model="esTicketInfo.sa_selected_autopilot"
                                                    :options="autopilotOptions"
                                                    name="autopilot-radio"
                                                    :disabled="!displayAutopilotTick"></b-form-radio-group>
                                <!-- selectedAutopilot :aria-describedby="ariaDescribedby" -->
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="header-col-mid" style="margin-top: 25px;" v-if="selectedAutopilot === 'Yes' ">
                    <div>
                      Autopilot Requirements
                      <span v-if="ifHasAutopilotReq" class="text-danger pl-1">*</span>
                    </div>
                    <div class="flex-fill">
                      <div v-if="selectedAutopilot === 'Yes' ">
                        <div v-if="ifHasAutopilotReq" class="alert alert-danger alert-dismissible" role="alert">
                          <strong>Attention!</strong>
                          The old consent link has been expired by Microsoft (MSFT passively notified us on 28th Feb 2024). Here is the new consent link we should provide to our customer for Autopilot Consent:
                          <a href="https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation" target="_blank">https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation</a>
                          <button type="button" class="close" data-dismiss="alert" aria-label="Close"></button>
                        </div>
                        <!-- Accept Getac consent Link:  -->
                        <div class="row">
                          <div class="col">
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div class="text-primary pl-1">
                                  Consent need to be accepted by the customer to authorize Getac as partner within the customer’s environment.
                                  <button type="button" class="btn btn-sm btn-link p-0 btn-svg gtc-icon-info"
                                          @click="showAutopilotInfoModal()"
                                          v-b-tooltip.hover.bottom
                                          title="Click for more info"></button>
                                  <b-modal ref="ConsentDetailModal"
                                           centered size="lg" :title="'About Customer Consent'" button-size="sm" hide-footer>
                                    <div class="d-block">
                                      <div v-html="safeHtml(autopilot_consent_text)"></div>
                                    </div>
                                  </b-modal>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <br />
                        <div class="row">
                          <div class="col">
                            <div>Tenant ID <span class="text-danger pl-1">*</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100" v-model="esTicketInfo.autopilot_info.tenant_id"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'tenant_id', ''), 50)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'tenant_id', '') | getInputLength }}/50</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div>Tenant Domain <span class="text-danger pl-1">*</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100" v-model="esTicketInfo.autopilot_info.tenant_domain"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'tenant_domain', ''), 200)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'tenant_domain', '') | getInputLength }}/200</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div>Customer IT Admin Email <span class="text-danger pl-1">*</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100" v-model="esTicketInfo.autopilot_info.admin_email_val"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'admin_email_val', ''), 200)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'admin_email_val', '') | getInputLength }}/200</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div>Group Tag <span v-if="esTicketInfo.autopilot_info.group_val !== null" style="font-style:italic">(Optional, If left blank, the group tag will not be set for customer.)</span></div>
                            <div class="flex-fill">
                              <div class="flex-wrap">
                                <div v-if="esTicketInfo !== null && _.get(esTicketInfo, 'autopilot_info', null) !== null">
                                  <textarea class="w-100"
                                            :placeholder="autoPilotGroupTagPlaceholders"
                                            v-model="esTicketInfo.autopilot_info.group_val"></textarea>
                                  <div :class="[classObject(_.get(esTicketInfo.autopilot_info, 'group_val', ''), 200)]">
                                    <span>You've input: {{ _.get(esTicketInfo.autopilot_info, 'group_val', '') | getInputLength }}/200</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>


                      </div>
                    </div>
                  </div>

                  <!-- EndRegion for AutoPilot-->

                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->
      <!-- #region: step-four: additional info for sector solution -->
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button block v-b-toggle.accordion-4
                      :variant="!isShowingCollapseFunc('accordion-4') ? 'secondary' : 'primary'"
                      :class="!isShowingCollapseFunc('accordion-4') ? 'text-dark' : 'text-white'"
                      style="text-align: left;">
              <b>
                <img src="../../../static/image/getac-icon-dash-dark.svg"
                     style="height: 0.8rem;width: 1rem;margin-right: 0.25rem;" alt="Getac Dashboard Dark Icon" />
                Additional Information for Sector Solution
              </b>
            </b-button>
          </b-card-header>
          <!-- v-if="isShowingCollapseFunc('accordion-4')" -->
          <b-collapse :visible="!visible"
                      id="accordion-4"
                      accordion="sector-solution-info"
                      role="tabpanel">
            <b-card-body>
              <div class="row mb-4">
                <div class="col-6">
                  <div class="header-col-mid">
                    <div>Industry</div>
                    <div>{{_.get(primaryInfoInputs, 'industry', null)}}</div>
                  </div>
                  <div class="header-col-mid">
                    <div>Vertical</div>
                    <div>{{_.get(primaryInfoInputs, 'vertical', null)}}</div>
                  </div>
                  <div class="header-col-mid">
                    <div>User group</div>
                    <div>{{_.get(esTicketInfo, 'sector_solution_info.user_group', null)}}</div>
                  </div>

                  <div class="header-col-mid">
                    <div>Environment</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.environment.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.environment.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.environment"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Scenario</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.scenario.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.scenario"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Behavior</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.behavior.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.behavior"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Pain Point</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.pain_point.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.pain_point"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div>
                  <img src="../../../static/image/gtc-vertical-line-sectsol.svg" alt="Sector Solution Vertical Line"/>
                </div>


                <div class="col-6" style="margin-left: -7px;">

                  <div class="header-col-mid">
                    <div>User Need</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.user_need.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.user_need.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.user_need"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Imaging Process</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.imaging_process.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.imaging_process.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.imaging_process"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Installation Process</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.installation_process.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.installation_process.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.installation_process"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Deployment Plan</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100">
                          <b-link v-b-tooltip.hover :title="_.get(esTicketInfo, 'sector_solution_info.placeholders.deployment_plan.text', '')">
                            Hover over to see an example
                          </b-link>
                        </div>
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.deployment_plan.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.deployment_plan"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>User Workflow</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100" style="height: 80px;"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.user_workflow.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.user_workflow"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="header-col-mid">
                    <div>Work Details</div>
                    <div class="flex-fill">
                      <div class="flex-wrap">
                        <div class="w-100" v-if="esTicketInfo !== null && _.get(esTicketInfo, 'sector_solution_info', null) !== null">
                          <textarea class="w-100"
                                    :placeholder="_.get(esTicketInfo, 'sector_solution_info.placeholders.work_details.text', '')"
                                    v-model="esTicketInfo.sector_solution_info.work_details"></textarea>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!--#endregion-->


    </div>
    <!--#endregion-->
    <!--#endregion Modal-->
    <b-modal centered ok-title="Delete" @ok="deleteAttachment"
             cancel-title="Cancel"
             ok-variant="danger"
             ref="DeleteAttachmentModal" title="Attachment Delete"
             button-size="sm">
      <div class="header-col pb-4">
        <div>Attachment</div>
        <div>{{ _.get(deleteAttachmentObj, 'FILE_NAME', '') }}</div>
      </div>
    </b-modal>
    <b-modal centered ok-title="Assign" @ok="assignTicket"
             cancel-title="Cancel"
             ok-variant="primary"
             ref="AssignTicketModal" title="Assign ticket"
             button-size="sm">

      <div class="row">
        <div class="col-auto">
          <div class="label mt-2">Assign Ticket Owner:</div>
        </div>
        <div class="col-auto">
          <b-form-select v-model="assigned_ticket_owner" :options="GTCOwnerList" label="Ticket Owner:"></b-form-select>
        </div>
      </div>
    </b-modal>

    <b-modal centered ok-title="Change" @ok="doChangeOwner"
             cancel-title="Cancel"
             ok-variant="primary"
             ref="ChangeOwnerModal" title="Change ES Owner"
             button-size="sm">

      <div class="row">
        <div class="col-auto">
          <div class="label mt-2">Transfer to:</div>
        </div>
        <div class="col-auto">
          <b-form-select v-model="tranfer_to_owner" :options="GROOwnerList" label="Ticket Owner:"></b-form-select>
        </div>
      </div>
    </b-modal>
    <!-- # region CloneEsModal -->
    <b-modal centered ok-variant="primary"
             ref="UnableToClone"
             hide-footer title="Unable to Clone"
             button-size="sm">
      <div>
        <p>
          <b>Sorry, the clone function only support the ticket created after the system migration (2022Q4)</b>.
        </p>
        <p>
          This ticket was too old to clone!
        </p>
      </div>
    </b-modal>

    <b-modal centered ok-title="Clone" @ok="doCloneES"
             cancel-title="Cancel"
             ok-variant="primary"
             ref="CloneEsModal" title="Clone Engineering Service"
             button-size="sm">
      <div>Are you sure want to clone this Engineering Service?</div>
      <br />
      <div>Please note that once you click clone, the new ES will be generated, but you still need to click Submit so that the ES will transfer to FTIE ticket.</div>
    </b-modal>
    <!--#endregion CloneEsModal-->
    <!--#endregion-->
    <div class="fixed-bottom d-print-none">
      <div class="row py-2 bg-gray-150 px-4 border-top border-gray-550">
        <!-- -->
        <div class="col-auto ml-auto p-0"></div>
        <template v-if="ftieId ==='' || ftieId === null">
          <div class="col-auto ml-auto">
          </div>
          <div v-if="ftieId ==='' || ftieId === null"
               style='width: 55rem; font-size: 0.9rem; padding-top: 0.8rem'>
            <p class="text-dark"><b>Remind:</b> {{notSubmitWarning}}</p>
          </div>
        </template>
        <template v-else>
          <div class="col-auto ml-auto">
          </div>
          <div v-if="ftieId !=='' && ftieId !== null"
               style="width: 55rem; font-size: 1rem; padding-top: 0.8rem">
            <p class="text-dark"><b>Hints:</b> {{sectorSolutionEditable}}</p>
          </div>
        </template>
        <div v-if="!checkSaveButtonDisabled() && esTicketInfo.ftie_id!==null" class="col-auto">
          <button v-if="!checkSaveButtonDisabled() && esTicketInfo.ftie_id!==null" type="button" class="btn btn-success min-w-6" @click="partialSaveValidate() && postEsExistFtieData()">Save</button>
        </div>
        <div class="col-auto" v-if="esTicketInfo !==null && esTicketInfo.ftie_id===null && !checkSaveButtonDisabled()">
          <button type="button" class="btn btn-success min-w-6" @click="validate() && lengthValidate() && saveData()">Save</button>
        </div>
        <div v-if="esTicketInfo !==null && esTicketInfo.ftie_id===null" class="col-auto border-left p-0 border-gray-550" style="width:1px"></div>
        <div class="col-auto" v-if="esTicketInfo !==null && esTicketInfo.ftie_id===null && !checkSaveButtonDisabled()">
          <!--
                  <button type="button" class="btn btn-danger" @click="$emit('reject')">Reject</button>
        -->
          <button type="button" class="btn btn-primary min-w-6" @click="validate() && lengthValidate() && validateCustomizationFieldsInput() && submitData()">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!--#endregion-->
  <!-- https://10.68.90.169:9001/ftie/NRE_FLOW/new_set_customer_pn.aspx?ftie_id=15993&detail_id=12188&request_form_id=2213 -->
  <!-- Old Page: FTIE 3.0-->

</template>
<script>
  import * as moment from 'moment/moment';
  import { safeUrl } from '@/helpers/vue-url';
  import { safeHtml } from '@/helpers/vue-safehtml';
  export default {
    data() {
      return {
        visible: false,
        esId: '', //encodeURIComponent(this.$route.params.es_id),
        defaultOptyInfo: null,
        sfdcOptyEsId: encodeURIComponent(this.$route.params.opty_id),
        ftieId: '', // encodeURIComponent(this.$route.params.ftie_id),
        detailId: '', // encodeURIComponent(this.$route.params.detail_id),
        requestFormId: '', // encodeURIComponent(this.$route.params.request_form_id),
        frontEndUrlToUse: this.$session.get('frontEndUrlToUse'),
        actionEnable: false,
        createBy: null,
        date_from: null,
        // isShowingCollapseTest: false,
        isShowingCollapse: {
          'accordion-1': true,
          'accordion-2': false,
          'accordion-3': false,
          'accordion-4': false
        },
        collapseFulfillStatus: {
          'accordion-1': false,
          'accordion-2': false,
          'accordion-3': false,
          'accordion-4': false
        },

        text: `(Please note that the customization request only open to the ticket which has opportunity.)
        `,
        breadcrumbItems: [
          {
            text: 'Engineering Service (SFDC)',
            active: true,
          },
          /*
          {
            text: this.esTicketInfo.es_ticket_status,
            active: true,
          },*/
        ],
        autopilot_consent_text: ` <ul>
<h5>Microsoft requires customer consent before allowing Getac to register devices for Autopilot.</h5>

<li>If customer have not provided consent, please provide link below and guide them to complete this step.
<br/>
<span style="font-weight:bold; color: red">[New Consent Link Updated by Microsoft Since 2024 Feb] </span>
<a href="https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation">
         https://admin.microsoft.com/Adminportal/Home?invType=OEM&partnerId=01c3a8ab-27fa-4d9c-8e50-f69ccf103a13#/partners/invitation </a>

<br/><b>(THIS LINK WILL ONLY WORK FOR AZURE GLOBAL ADMINISTRATORS. IT WILL BE BROKEN FOR EVERYONE ELSE)</b>
  </li>
<li>Here is a Microsoft Article that shows the process.
If your customer has never performed this process before, this link will be an excellent guide<br/>
<a href="https://docs.microsoft.com/en-us/mem/autopilot/registration-auth">https://docs.microsoft.com/en-us/mem/autopilot/registration-auth</a>
</li>
<li>If your customer does not know how to get their Tenant ID, Name, or Admin Email,
please send them the following:<br/>
<a href="https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/how-to-find-tenant">https://learn.microsoft.com/en-us/azure/active-directory/fundamentals/how-to-find-tenant</a>
</li>
</ul>`,
        searching: false,
        searchingNre: false,
        searchingStdSku: false,
        esTicketInfo: null,
        esTicketOriginalInfo: null,
        basicInfo: null,
        refSkuList: null,
        selectedRefSkuIndex: null,
        selectedRefSkuItems: [],
        saveRefSkuError: null,
        skuPnListForNre: null,
        sfdcProducts: null,
        nreRemarkWarning: null,
        // selectedAutopilot: null,
        autopilotOptions: [{ text: 'No', value: 'No' }, { text: 'Yes', value: 'Yes' },],
        missingData: 'N/A (Old data not found)',
        updateSuccessNotification: null,
        updateFailedNotification: null,
        notSubmitWarning: `ES initiated! However the service hasn't transferred to FTIE. Please input the required fields then click the SUBMIT to complete.
        `,
        sectorSolutionEditable: `The Additional Info for Sector Solution part is open to SA/ES PM to edit. Remember to save the changes if have any.
        `,
        readOnly: false,
        selectRsm: null,
        configuration: '',
        statusOptions: [ 'New' ,'Close', 'Open', 'In-Process', 'Deferred'],
        rsmOptions: [],
        optyOptions: [],
        optyOptionsTmp: [],
        optyInfoObjList: [],
        all_model_list: [],
        accountOptions: [],
        accountOptionsTmp: [],
        issueCategoryList: [],
        //whyNeedEsOptions: [],
        whyNeedEsOptionsTmp: [],
        typeOfIssueOptions: [],
        requirementStageOptions: [],
        attach_files: [],
        attachFileFields: [
          {
            key: 'file_name', label: 'File Name',
            // thClass: 'align-middle',
            tdClass: 'min-w-187',
            thStyle: { width: "80%" },
            sortable: true
          },
          { key: 'delete', label: '', thClass: 'align-middle', sortable: false },
        ],
        priority_options: ['High', 'Medium', 'Low'],
        /* end region */

        /* region: input for step 1*/
        primaryInfoInputs: {
          rsm: null,
          accountId: null,
          optyId: null,
          vertical: null,
          industry: null,
          modelList: null,
          esPurpose: null,
          typeOfIssue: null,
          requirementStage: null,
        },
        /* end region */
        tech_info_priority: '',
        tech_info_due_date: '',
        tech_info_model: '',
        deleteAttachmentObj: { ATTACHMENT_ID: null, FILENAME: null },
        GTCOwnerList: [],
        GROOwnerList: [],
        assigned_ticket_owner: '',
        tranfer_to_owner: '',
        autoPilotGroupTagPlaceholders: 'Optional. If left blank, the group tag will not be set for customer.',
      };
    },
    created() {
      let self = this;
      self.date_from = moment().format('YYYY-MMM-DD');
      let callback = () => {
        if (!self.readOnly) {
          console.log("!self.readOnly!");
        }
        //#region ¥¼Àx¦s´£¥Ü

        $(window).on('beforeunload', function () {
          if (!self.readOnly && JSON.stringify(self.esTicketInfo) !== JSON.stringify(self.esTicketOriginalInfo)) {
            return "You have made changes on this page that you have not yet confirmed.\nIf you navigate away from this page you will lose your unsaved changes";
          }
        });

        //#endregion
      };

      self.getPage();
      self.get_ftie_gtc_owner_list();
      self.actionEnable = self.checkActionEnable();
      //console.log("ES Ticket Page actionEnable:");
      //console.log(self.actionEnable);
      // self.buildFakeData();
    },
    computed: {
      loginUser() {
        return _.get(this.$store, 'state.username', null);
      },
      userFunctions() {
        return this.$session.get('user_functions');
      },
      selectedAutopilot: {
        get() {
          if (this.esTicketInfo !== null) {
            return _.get(this.esTicketInfo, 'sa_selected_autopilot', null);
          } else {
            return null;
          }
        },
        set(selectedAutopilotVal) {
          if (this.esTicketInfo !== null) {
            _.get(this.esTicketInfo, 'sa_selected_autopilot', null);
          }
        }
      },
      userRoles() {
        return this.$session.get('user_roles');
      },
      esFullPageEditbale() {
        return _.isNull(_.get(this.esTicketInfo, 'ftie_id', null))
      },
      displayAutopilotTick() {
        if (_.isNull(_.get(this.primaryInfoInputs, 'esPurpose', null)) || _.get(this.primaryInfoInputs, 'esPurpose', null) === 'Asks to customize existing Getac products for special items.' || _.get(this.primaryInfoInputs, 'esPurpose', null) === 'Asks for a new Getac PN/BOM since it is not ready on eQuote yet.') {
          return true;
        }
        else {
          if (this.esTicketInfo !== null) {
            _.set(this.esTicketInfo, 'sa_selected_autopilot', null);
          }
          return false; // non customization purpose ES, do not display the autopilot tick
        }
      },
      ifHasAutopilotReq() {
        if (!_.isNull(_.get(this.primaryInfoInputs, 'typeOfIssue', null)) &&
          'Software - Autopilot' === _.get(this.primaryInfoInputs, 'typeOfIssue', null)) {
          return true;
        } else {
          if (this.selectedAutopilot === 'Yes' || (this.esTicketInfo !== null && _.get(this.esTicketInfo, 'sa_selected_autopilot', null) === 'Yes')) {
            return true;
          }
          else {
            return false
          }
        }
      },
      sfdcInfoIsAllSet() {
        if ((!_.isNull(_.get(this.primaryInfoInputs, 'rsm', null)) &&
          (!_.isNull(_.get(this.primaryInfoInputs, 'accountId', null)) || !_.isNull(_.get(this.primaryInfoInputs, 'optyId', null))))) {
          return true;
        }
        else {
          return false
        }
      },

      primaryInfoAllSet() {
        if (!_.isNull(_.get(this.primaryInfoInputs, 'esPurpose', null)) &&
          !_.isNull(_.get(this.primaryInfoInputs, 'typeOfIssue', null)) &&
          !_.isNull(_.get(this.primaryInfoInputs, 'requirementStage', null))) {

          _.set(this.isShowingCollapse, 'accordion-2', true);
          _.set(this.collapseFulfillStatus, 'accordion-1', true);

          return true;
        }
        else {
          _.set(this.isShowingCollapse, 'accordion-2', false);
          _.set(this.collapseFulfillStatus, 'accordion-1', false);
          return false
        }

      },

      whyNeedEsOptions() {
        //return this.whyNeedEsOptions.filter(data => data.name != 'Ragnar'); deal with array of obj
        if (_.isNull(_.get(this.primaryInfoInputs, 'optyId', null))
          || _.isNull(_.get(this.primaryInfoInputs, 'optyId.value', null))
          || _.get(this.primaryInfoInputs, 'optyId.value', null) === '') {
          let customization = 'Asks to customize existing Getac products for special items.';
          /*
          let tmp = this.whyNeedEsOptionsTmp.filter(function (value, index, arr) {
            return value !== 'Asks to customize existing Getac products for special items.';
          });*/

          let tmp = this.whyNeedEsOptionsTmp.filter(function (item) {
            return item !== customization;
          })

          //return tmp;
          return JSON.parse(JSON.stringify(tmp));
        }
        else {
          return JSON.parse(JSON.stringify(this.whyNeedEsOptionsTmp));
        }
      },
      sfdc_source_mapping() {
        let self = this;
        let source = "";
        let indexOfEsPurpose = _.findIndex(self.issueCategoryList, { 'request_type': _.get(self.primaryInfoInputs, 'esPurpose', null) });
        if (indexOfEsPurpose !== null && indexOfEsPurpose !== -1) {
          let category_mapping_info_list = _.get(self.issueCategoryList[indexOfEsPurpose], 'category_mapping_info_list', new Array());//_.mapValues(_.at(self.issueCategoryList, indexOfEsPurpose), function (v) { return v['issue_type']; });
          let indexOfrequirementStage = _.findIndex(category_mapping_info_list, { 'ETO_SOURCE': _.get(self.primaryInfoInputs, 'requirementStage', null) });
          if (indexOfrequirementStage !== null && indexOfrequirementStage !== -1 && self.esTicketInfo !== null) {
            source = _.get(category_mapping_info_list[indexOfrequirementStage], 'SFDC_SOURCE', '');
            _.set(self.esTicketInfo, 'source', source);
          }
        }

        return JSON.parse(JSON.stringify(source));
      },
      sfdc_issue_type_mapping() {
        let self = this;
        let issue_type = "";
        let indexOfEsPurpose = _.findIndex(self.issueCategoryList, { 'request_type': _.get(self.primaryInfoInputs, 'esPurpose', null) });
        if (indexOfEsPurpose !== null && indexOfEsPurpose !== -1) {
          let category_mapping_info_list = _.get(self.issueCategoryList[indexOfEsPurpose], 'category_mapping_info_list', new Array());//_.mapValues(_.at(self.issueCategoryList, indexOfEsPurpose), function (v) { return v['issue_type']; });
          let indexOftypeOfIssue = _.findIndex(category_mapping_info_list, { 'ETO_SOURCE': _.get(self.primaryInfoInputs, 'requirementStage', null), 'ETO_ISSUE_TYPE': _.get(self.primaryInfoInputs, 'typeOfIssue', null) });
          if (indexOftypeOfIssue !== null && indexOftypeOfIssue !== -1 && self.esTicketInfo !== null) {
            issue_type = _.get(category_mapping_info_list[indexOftypeOfIssue], 'SFDC_ISSUE_TYPE', '');
            _.set(self.esTicketInfo, 'issue_type', issue_type);
          }
        }
        return JSON.parse(JSON.stringify(issue_type));
      },
      sfdc_request_type_mapping() {
        let self = this;
        let request_type = "";
        let indexOfEsPurpose = _.findIndex(self.issueCategoryList, { 'request_type': _.get(self.primaryInfoInputs, 'esPurpose', null) });
        if (indexOfEsPurpose !== null && indexOfEsPurpose !== -1) {
          let category_mapping_info_list = _.get(self.issueCategoryList[indexOfEsPurpose], 'category_mapping_info_list', new Array());//_.mapValues(_.at(self.issueCategoryList, indexOfEsPurpose), function (v) { return v['issue_type']; });
          let indexOftypeOfIssue = _.findIndex(category_mapping_info_list, { 'ETO_SOURCE': _.get(self.primaryInfoInputs, 'requirementStage', null), 'ETO_ISSUE_TYPE': _.get(self.primaryInfoInputs, 'typeOfIssue', null) });
          if (indexOftypeOfIssue !== null && indexOftypeOfIssue !== -1) {
            self.esTicketInfo.request_type = _.get(category_mapping_info_list[indexOftypeOfIssue], 'SFDC_REQUEST_TYPE', '');
            request_type = _.get(category_mapping_info_list[indexOftypeOfIssue], 'SFDC_REQUEST_TYPE', '');
            _.set(self.esTicketInfo, 'request_type', request_type);
          }
        }
        return JSON.parse(JSON.stringify(request_type));
      },
      closeReasonReadOnly() {
        let self = this;
        let es_status = _.get(self.esTicketInfo, 'es_ticket_status', null)
        if (es_status !== null && es_status == 'Close') {
          return false;
        } else {
          return true;
        }
      },
      userEditable() {
        let self = this;
        if (self.esTicketInfo != null && self.esTicketOriginalInfo != null) {
          let cur = JSON.stringify(self.esTicketInfo);
          let origin = JSON.stringify(self.esTicketOriginalInfo);
          if (cur !== origin || _.get(self.primaryInfoInputs, 'esPurpose', null) !== _.get(self.esTicketInfo, 'primary_info.es_purpose', null)
            || _.get(self.primaryInfoInputs, 'typeOfIssue', null) !== _.get(self.esTicketInfo, 'primary_info.matching_issue', null)
            || _.get(self.primaryInfoInputs, 'requirementStage', null) !== _.get(self.esTicketInfo, 'primary_info.requirement_stage', null)) {
            return true;
          }
        }
        return false;
      },
      techInfoDuplicate() {
        let self = this;
        let check_duplicate_columns = [self.esTicketInfo.tech_info.es_issue, self.esTicketInfo.tech_info.third_party_application, self.esTicketInfo.tech_info.impact,
          self.esTicketInfo.tech_info.configuration, self.esTicketInfo.tech_info.detailed_spec, self.esTicketInfo.tech_info.user_scenario]

        let notEmptyColumns = _.filter(check_duplicate_columns, item => { return item !== "" && item !== null; });
        let uniqueLength = _.uniq(notEmptyColumns).length;
        if (notEmptyColumns.length !== uniqueLength) {
          return true;
        }
        return false;
      }
    },
    methods: {
      prdEnv() {
        return 'PRD' === this.$session.get('mode');
      },
      showAutopilotInfoModal() {
        this.$refs['ConsentDetailModal'].show()
      },
      classObject(input, maxLength) {
        return {
          'text-danger': this.$options.filters['reachLength'](input, maxLength),
          'text-success': !this.$options.filters['reachLength'](input, maxLength),
          'text-weight': this.$options.filters['reachLength'](input, maxLength) ? 'bold' : 'normal'//,
        }
      },
      clearIssueCategoy() {
        let self = this;
        _.set(self.primaryInfoInputs, 'esPurpose', null);
        _.set(self.primaryInfoInputs, 'typeOfIssue', null);
        _.set(self.primaryInfoInputs, 'requirementStage', null);
      },
      clearVerticalIndustryModelList() {
        let self = this;
        _.set(self.primaryInfoInputs, 'vertical', null);
        _.set(self.primaryInfoInputs, 'industry', null);
        _.set(self.primaryInfoInputs, 'modelList', null);
      },
      clearPrimaryInfoInput() {
        let self = this;
        _.set(self.primaryInfoInputs, 'rsm', null);
        _.set(self.primaryInfoInputs, 'accountId', null);
        _.set(self.primaryInfoInputs, 'optyId', null);
        self.clearVerticalIndustryModelList();
        self.clearIssueCategoy();
        self.optyOptions = [];
        self.accountOptions = [];
      },
      isShowingCollapseFunc(accordionId) {
        let self = this;
        return _.get(self.isShowingCollapse, accordionId, false);
      },

      // Toggle Both Collapse A and B (by IDS list)
      toggleCollapses(ids) {
        ids.forEach((id) => {
          this.$root.$emit('bv::toggle::collapse', id)
        })
      },

      checkActionEnable() {
        let self = this;
        if (!this.$session.has('user_name')) {
          this.$router.push("/");
        }
        // loginUser is gtc owner
        if (self.loginUser !== null && self.createBy !== null && self.loginUser === self.createBy) {
          return true;
        }
        if (self.userRoles !== null && _.size(self.userRoles) > 0) {
          if (_.indexOf(self.userRoles, 'ES_PM_Leader') > -1 || _.indexOf(self.userRoles, 'Admin') > -1) {
            return true;
          }
        }
        if (self.userFunctions !== null && _.size(self.userFunctions) > 0) {
          if (_.indexOf(self.userFunctions, 'ES PM Leader') > -1 || _.indexOf(self.userFunctions, 'Tech Leader') > -1) {
            return true;
          }
        }
        return false;
      },
      setPrimaryInfoInputValue(index) {
        let self = this;
        if (index > -1) {
          self.primaryInfoInputs.vertical = self.optyInfoObjList[index]['vertical'];
          self.primaryInfoInputs.industry = self.optyInfoObjList[index]['industry'];
          //self.primaryInfoInputs.modelList = self.optyInfoObjList[index]['model_list'];
        }
        /*
        else {
          self.primaryInfoInputs.modelList = self.all_model_list;
        }*/
      },
      updateAutopilotChoice() {
        let self = this;
        let originalFlag = null;
        if (self.esTicketInfo !== null) {
          originalFlag = _.get(self.esTicketInfo, 'sa_selected_autopilot', null);
        }
        if ('Software - Autopilot' === _.get(self.primaryInfoInputs, 'typeOfIssue', null)) {
          _.set(self.esTicketInfo, 'sa_selected_autopilot', 'Yes'); //self.selectedAutopilot = 'Yes'
        } else {
          if ('Yes' === originalFlag) {
            //used to be need autopilot, yet change the issue type to another
            _.set(self.esTicketInfo, 'sa_selected_autopilot', null);
          }
        }
       /*
        *
        else {
          if (_.get(self.primaryInfoInputs, 'esPurpose', null) !== 'Asks to customize existing Getac products for special items.') {
            // self.selectedAutopilot = 'No';
            _.set(self.esTicketInfo, 'sa_selected_autopilot', 'No');
          } else {
            // self.selectedAutopilot = null;
            _.set(self.esTicketInfo, 'sa_selected_autopilot', null);
          }
        } */ // use computed attribute: displayAutopilotTick() to control the flag*/
      },
      resetAccountOpty() {
        let self = this;
        _.set(self.primaryInfoInputs, 'accountId', { 'value': '', 'text': '' });
        _.set(self.primaryInfoInputs, 'optyId', { 'value': '', 'text': '' });
        self.clearIssueCategoy();
        self.clearVerticalIndustryModelList();
        self.optyOptions = self.optyOptionsTmp;
        self.accountOptions = self.accountOptionsTmp
      },
      onChangeIssueCategory() {
        let self = this;
        if (_.get(self.primaryInfoInputs, 'esPurpose', null) !== null
          && _.get(self.primaryInfoInputs, 'esPurpose', null) !== ''
          && self.issueCategoryList !== null && _.size(self.issueCategoryList) !== 0) {
          let indexOfEsPurpose = _.findIndex(self.issueCategoryList, { 'request_type': _.get(self.primaryInfoInputs, 'esPurpose', null) });
          //_.map(_.keys(_.pickBy(self.issueCategoryList, { request_type: _.get(self.primaryInfoInputs, 'esPurpose', null) })), Number);


          if (indexOfEsPurpose !== null && indexOfEsPurpose !== -1) {
            let issueTypeList = _.get(self.issueCategoryList[indexOfEsPurpose], 'issue_type', new Array());//_.mapValues(_.at(self.issueCategoryList, indexOfEsPurpose), function (v) { return v['issue_type']; });
            let sourceList = _.get(self.issueCategoryList[indexOfEsPurpose], 'source', new Array()); //_.mapValues(_.at(self.issueCategoryList, indexOfEsPurpose), function (v) { return v['source']; });
            self.typeOfIssueOptions = JSON.parse(JSON.stringify(issueTypeList));
            self.requirementStageOptions = JSON.parse(JSON.stringify(sourceList));
            _.set(self.primaryInfoInputs, 'typeOfIssue', null);
            _.set(self.primaryInfoInputs, 'requirementStage', null);

          }
        }
      },
      onChangeByAccount() {
        let self = this;
        if (_.get(self.primaryInfoInputs, 'accountId', '') !== ''
          && self.optyInfoObjList !== null) {
          let indexOfSameAccount = _.map(_.keys(_.pickBy(self.optyInfoObjList, { account_id: _.get(self.primaryInfoInputs, 'accountId.value', null) })), Number);
          let accountName = null;
          if (indexOfSameAccount !== null && _.size(indexOfSameAccount) > 0) {
            accountName = _.get(self.optyInfoObjList[indexOfSameAccount[0]], 'account_name', null);
            let optyList = _.mapValues(_.at(self.optyInfoObjList, indexOfSameAccount), function (v) { return v['opty_id']; });

            self.clearIssueCategoy();
            self.clearVerticalIndustryModelList();
            self.primaryInfoInputs.modelList = self.all_model_list;
            _.set(self.primaryInfoInputs, 'optyId', { 'value': '', 'text': '' });
            _.set(self.primaryInfoInputs,'modelList', self.all_model_list);
            let optyFilterOptions = _.filter(self.optyOptionsTmp, item => { return _.values(optyList).includes(item.value); })
            optyFilterOptions.unshift({ 'text': '', 'value': '' });
            _.set(self.optyOptions, optyFilterOptions);

            self.optyOptions = optyFilterOptions;
          } else {
            self.primaryInfoInputs.modelList = self.all_model_list;
          }
          //console.log("accountName for self.getModelOptions() ::");
          //console.log(accountName);
          self.getModelOptions(accountName, null);
        }
        if (_.get(self.primaryInfoInputs, 'accountId.value', '') === ''){
          self.primaryInfoInputs.optyId = { 'value': '', 'text': '' };
        }
      },
      onChangeByOpty() {
        let self = this;
        let optyName = null;
        let accountName = null;
        if (_.get(self.primaryInfoInputs, 'optyId', { 'value': '', 'text': '' }) !== { 'value': '', 'text': '' }
          && self.optyInfoObjList !== null) {
          let index = _.findIndex(self.optyInfoObjList, { 'opty_id': _.get(self.primaryInfoInputs, 'optyId.value', null) });

          if (index !== -1
            && _.get(self.primaryInfoInputs, 'optyId', { 'value': '', 'text': '' }) !== { 'value': '', 'text': '' }
            && _.get(self.optyInfoObjList[index], 'account_id', null) !== null) {
            self.primaryInfoInputs.accountId = { 'value': _.get(self.optyInfoObjList[index], 'account_id', null), 'text': _.get(self.optyInfoObjList[index], 'account_name', null) };
            optyName = _.get(self.optyInfoObjList[index], 'opty_name', null);
            accountName = _.get(self.optyInfoObjList[index], 'account_name', null);
            _.set(self.esTicketInfo, 'tech_info.model', null);
            self.clearIssueCategoy();
            self.clearVerticalIndustryModelList();
            self.setPrimaryInfoInputValue(index);
            self.getModelOptions(accountName, optyName);
          } else {
            _.set(self.esTicketInfo, 'tech_info.model', null);
            self.getModelOptions(accountName, null);
          }
        } else {
          _.set(self.esTicketInfo, 'tech_info.model', null);
          self.primaryInfoInputs.modelList = self.all_model_list;
        }
      },
      getModelOptions(accountName, optyName) {
        let self = this;
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
          site: self.$session.get('user_site'),
          account_name: accountName,
          opty_name: optyName,
          account_id: _.get(self.primaryInfoInputs, 'accountId.value', null),
          opty_id: _.get(self.primaryInfoInputs, 'optyId.value', null),
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/options/models/', requestData)
          .then(res => {
            let result = res.data;
            //console.log(result);
            self.all_model_list = result.model_list;
            self.primaryInfoInputs.modelList = result.model_list;
          })
          .finally(() => {
            console.log("COMPLETE .../models/");
            self.searching = false;
            eventHub.$emit('loading', false);
          });
      },

      getOptions() {
        let self = this;
        _.set(self.esTicketInfo, 'primary_info.cooperate_rsm', _.get(self.primaryInfoInputs, 'rsm.value', null));
        let requestData = {
          create_by: self.loginUser,
          username: self.loginUser,
          rsm_name: _.get(self.esTicketInfo, 'primary_info.cooperate_rsm', null),
          site: self.$session.get('user_site')
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/options/opty-and-account/', requestData)
          .then(res => {
            let result = res.data;
            //console.log(result);
            if (result.opty_obj_list !== null && _.size(result.opty_obj_list) !== 0) {
              result.opty_obj_list = JSON.parse(result.opty_obj_list);
            }
            // ------ --- --- --- ---  BUILD ACCOUNT/OPTY OPTION LIST--- --- ---
            // result.opty_name_list = result.opty_name_list;
            // result.account_list = result.account_list;
            self.optyInfoObjList = result.opty_obj_list;
            self.all_model_list = result.model_list;

            /* new way:: build optyArray from B.E.*/
            if (result.opty_option !== null && _.size(result.opty_option) !== 0) {
              result.opty_option = JSON.parse(result.opty_option);
            }
            self.optyOptions = result.opty_option;
            self.optyOptionsTmp = result.opty_option;
            self.optyOptions.unshift({ 'text': '', 'value':''});
            /* new way:: build accountOptions from B.E.*/

            /* new way:: build accountOptions from B.E.*/
            if (result.account_option !== null && _.size(result.account_option) !== 0) {
              result.account_option = JSON.parse(result.account_option);
            }
            self.accountOptions = result.account_option;
            self.accountOptionsTmp = result.account_option;
            self.accountOptions.unshift({ 'text': '', 'value': '' });

            /* END REGION */
          })
          .finally(() => {
            console.log("COMPLETE /engineering-service/options/opty-and-account/");
            self.resetAccountOpty();
            let account = _.find(self.accountOptions, { value: _.get(self.esTicketInfo, 'account_id', null) });
            let opty = _.find(self.optyOptions, { value: _.get(self.esTicketInfo, 'opty_master_id', null) });
            _.set(self.primaryInfoInputs, 'accountId', account);
            _.set(self.primaryInfoInputs, 'optyId', opty);
            //console.log(self.primaryInfoInputs.accountId);
            //console.log(self.primaryInfoInputs.optyId);
            let accountName = _.get(account, 'text', null);
            let optyName = _.get(opty, 'text', null);
            self.getModelOptions(accountName, optyName);
            self.getIssueCategoryOptions();
            let index = _.findIndex(self.optyInfoObjList, { 'opty_id': _.get(self.esTicketInfo, 'opty_master_id', null) });
            self.setPrimaryInfoInputValue(index);
            self.searching = false;
            eventHub.$emit('loading', false);
          });
      },

      getPage(callback) {
        let self = this;
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
          es_ticket_id: self.esId,
          opty_id: self.sfdcOptyEsId,
          site: self.$session.get('user_site'),
          es_under_opty_id: '',
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        let urlByServiceId = self.$root.baseUrl + '/engineering-service/back-end/service-id/';
        let urlByOptyId = self.$root.baseUrl + '/engineering-service/back-end/opty-id/';
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/back-end/opty-id/' + self.sfdcOptyEsId, requestData)
          .then(res => {
            let result = res.data;
            result.es_ticket_info = JSON.parse(result.es_ticket_info);
            // result.cooperate_rsm_option = result.cooperate_rsm_option;
            console.log("result.es_ticket_info::");
            //console.log(result.es_ticket_info);
            console.log("result.cooperate_rsm_option::");
            //console.log(result.cooperate_rsm_option);
            // -- REGION: GET OPTION WHEN GET PAGE --
            self.rsmOptions = result.cooperate_rsm_option;
            self.esTicketInfo = result.es_ticket_info;
            self.ftieId = self.esTicketInfo.ftie_id;
            self.esId = self.esTicketInfo.es_id;
            self.sfdcOptyEsId = self.esTicketInfo.opty_obj_id;
            self.createBy = self.esTicketInfo.es_ticket_create_by;
          })
          .finally(() => {
            console.log("COMPLETE /.../back-end/.../");
            if (self.esTicketInfo !== null) {
              self.esTicketOriginalInfo = JSON.parse(JSON.stringify(self.esTicketInfo));
              //console.log("esTicketOriginalInfo getPage::");
              //console.log(self.esTicketOriginalInfo);
              self.selectedAutopilot = _.get(self.esTicketInfo, 'sa_selected_autopilot', null);
              //console.log("When vue created.getPage(), _.get(self.esTicketInfo, 'sa_selected_autopilot', null) : ");
              //console.log(_.get(self.esTicketInfo, 'sa_selected_autopilot', null));
            }
            let rsm = _.find(self.rsmOptions, { value: _.get(self.esTicketInfo, 'primary_info.cooperate_rsm', null) });
            _.set(self.primaryInfoInputs, 'rsm', rsm);
            self.resetAccountOpty();
            self.getOptions();
            self.searching = false;
            self.actionEnable = self.checkActionEnable();
            self.getEsAttachmentList();
            eventHub.$emit('loading', false);
            if (self.updateSuccessNotification !== null) {
              self.updateFailedNotification = null;
              self.$message.info(`${self.updateSuccessNotification} You could refer to the FTIE ticket with ID ${_.get(self.esTicketInfo, 'ftie_id', 'display on the top of section')}.`);
            }
            else {
              if (self.updateFailedNotification !== null) {
                self.$message.error(`${self.updateFailedNotification}`);
              }
            }
            if (self.ftieId === null || self.ftieId === '') {
              self.visible = true;
            }
          });
      },
      getIssueCategoryOptions() {
        let self = this;
        let requestData = {
          create_by: self.createBy,
          username: self.loginUser,
        };
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/options/issue-category/', requestData)
          .then(res => {
            let result = res.data;
            result.category_option_list = JSON.parse(result.category_option_list);
            self.issueCategoryList = result.category_option_list;
            //self.whyNeedEsOptions = result.eto_request_type_list;
            self.whyNeedEsOptionsTmp = result.eto_request_type_list;
          })
          .finally(() => {
            console.log("COMPLETE .../options/issue-category/");
            _.set(self.primaryInfoInputs, 'esPurpose', _.get(self.esTicketInfo, 'primary_info.es_purpose', null));
            self.onChangeIssueCategory();
            _.set(self.primaryInfoInputs, 'typeOfIssue', _.get(self.esTicketInfo, 'primary_info.matching_issue', null));
            _.set(self.primaryInfoInputs, 'requirementStage', _.get(self.esTicketInfo, 'primary_info.requirement_stage', null));
          });
      },


      setEsPrimaryInfo() {
        let self = this;
        let account = _.find(self.accountOptions, { value: _.get(self.primaryInfoInputs, 'accountId.value', null) });
        let account_name = '';
        if (account) {
          account_name = account.text;
        }
        let opty = _.find(self.optyOptions, { value: _.get(self.primaryInfoInputs, 'optyId.value', null) });
        let opty_name = '';
        if (opty) {
          opty_name = opty.text;
        }
        _.set(self.esTicketInfo, 'primary_info.cooperate_rsm', _.get(self.primaryInfoInputs, 'rsm.value', null));
        _.set(self.esTicketInfo, 'primary_info.account_id', _.get(self.primaryInfoInputs, 'accountId.value', null));
        _.set(self.esTicketInfo, 'primary_info.opty_id', _.get(self.primaryInfoInputs, 'optyId.value', null));
        _.set(self.esTicketInfo, 'primary_info.account_name', account_name);
        _.set(self.esTicketInfo, 'primary_info.opty_name', opty_name);
        _.set(self.esTicketInfo, 'primary_info.es_purpose', _.get(self.primaryInfoInputs, 'esPurpose', null));
        _.set(self.esTicketInfo, 'primary_info.matching_issue', _.get(self.primaryInfoInputs, 'typeOfIssue', null));
        _.set(self.esTicketInfo, 'primary_info.requirement_stage', _.get(self.primaryInfoInputs, 'requirementStage', null));
        if (self.displayAutopilotTick === false) {
          _.set(self.esTicketInfo, 'sa_selected_autopilot', null);
        }
      },

      postEsData(action) {
        let self = this;
        self.setEsPrimaryInfo();
        if ('submit' === action) {
          _.set(self.esTicketInfo, 'es_ticket_status', 'In-Process');
        }
        _.set(self.esTicketInfo, 'create_by', _.get(self.esTicketInfo, 'es_ticket_create_by', null));
        _.set(self.esTicketInfo, 'sector_solution_info.industry', _.get(self.primaryInfoInputs, 'industry', null));
        _.set(self.esTicketInfo, 'sector_solution_info.vertical', _.get(self.primaryInfoInputs, 'vertical', null));
        _.set(self.esTicketInfo, 'action', 'Save');
        //console.log("before postEsData, esTicketOriginalInfo.sa_selected_autopilot=");
        //console.log(_.get(self.esTicketOriginalInfo, 'sa_selected_autopilot', null));
        //console.log("postEsData -> _.get(self.esTicketInfo, 'sa_selected_autopilot', null)");
        //console.log(_.get(self.esTicketInfo, 'sa_selected_autopilot', null));
        let autopilot_info_change_flag = false;
        if (JSON.stringify(self.esTicketInfo.autopilot_info) !== JSON.stringify(self.esTicketOriginalInfo.autopilot_info)) {
          autopilot_info_change_flag = true
        }
        if (_.get(self.esTicketInfo, 'sa_selected_autopilot', null) !== _.get(self.esTicketOriginalInfo, 'sa_selected_autopilot', null)) {
          autopilot_info_change_flag = true
        }
        let requestData = {
          input_info: JSON.parse(JSON.stringify(self.esTicketInfo)),
          create_by: self.esTicketInfo.create_by,
          username: self.loginUser,
          site: self.$session.get('user_site'),
          autopilot_info_change_flag: autopilot_info_change_flag,
          original_autopilot_info: self.esTicketOriginalInfo.autopilot_info,
          original_tag_sa_selected_autopilot: _.get(self.esTicketOriginalInfo, 'sa_selected_autopilot', null),
        }
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/' + action + '/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'save_success', false)) {
              console.log("result.save_success::");
              console.log(_.get(result, 'save_success', false));
              self.updateFailedNotification = null;
              if (action === 'submit' || _.get(self.esTicketInfo, 'ftie_id', null) !== null) {
                if ('submit' === action) {
                  self.updateSuccessNotification = "The engineering service has been submit successfully!";
                }
                else {
                  self.updateSuccessNotification = "The engineering service has been updated successfully!";
                }

              }
              else {
                self.updateSuccessNotification = null;
              }
            } else {
              let erroMsg = '';
              self.updateSuccessNotification = null;
              self.updateFailedNotification = `${action} engineering service failed!`;
              //self.$message.error(`${self.updateFailedNotification}`);
            }
          })
          .finally(() => {
            console.log("COMPLETE /engineering-service/" + action);
            self.searching = false;
            self.actionEnable = self.checkActionEnable();
            eventHub.$emit('loading', false);
            self.getPage();
          });
      },
      saveData() {
        this.postEsData('save');
      },
      submitData() {
        this.postEsData('submit');
      },
      getEsAttachmentList() {
        let self = this;
        let requestData = {
          username: self.loginUser,
          es_id: _.get(self.esTicketInfo, 'opty_obj_id', null) //self.esTicketInfo.opty_obj_id
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/attachment/list/', requestData)
          .then(response => {
            let res = response.data;
            //console.log(res);
            //console.log(response);

            if (response.status === 200) {
              self.attach_files = JSON.parse(res.attachment_list);
            }

            else if (response.status === 204) {
              self.attach_files = [];
            }

            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }

          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      uploadAttachment(event, es_id) {
        let self = this;
        if (self.checkAllDataSaved('Upload File')) {
          let maxLength = Number(self.$root.maxRequestLength);
          if (event) event.preventDefault();
          if (event.target.files.length === 0) return;
          if (_.first(event.target.files).size > maxLength) {
            self.$message.warning('Maximum limit for exceeding single file uploads (10MB)');
            return;
          }
          //#region -- formData --
          let formData = new FormData();
          formData.append('file', _.first(event.target.files));
          formData.append('es_id', es_id);
          formData.append('user_name', self.loginUser);
          //#endregion

          //#region -- Data Upload --

          eventHub.$emit('loading', true);
          self.$axios
            .post(
              self.$root.baseUrl + '/engineering-service/attachment/',
              formData,
              { headers: { 'Content-Type': 'multipart/form-data' } }
            )
            .then(res => {
              self.getPage()
            })
            .finally(() => {
              eventHub.$emit('loading', false);
            });
        } else {
          event.target.value = null;
        }

      },
      showDeleteAttachmentModal(attachment_id, file_name) {
        let self = this;
        self.deleteAttachmentObj = { ATTACHMENT_ID: attachment_id, FILE_NAME: file_name };
        self.$refs['DeleteAttachmentModal'].show();
      },
      deleteAttachment() {
        let self = this;
        let requestData = {
          user_name: self.loginUser,
          attachment_id: self.deleteAttachmentObj.ATTACHMENT_ID
        };
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/attachment/delete/', requestData)
          .then(response => {
            let res = response.data;
            //console.log(res);
            //console.log(response);

            if (response.status === 200) {
              if (_.get(res, 'delete_success', false)) {
              }
            }
            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location.href = self.authUrl + 'Auth/SignOut?redirect_uri=' + encodeURIComponent(self.frontendUrl + 'azure-login');
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }

          })
          .finally(() => {
            self.deleteAttachmentObj = { attachment_id: null, file_name: null };
            self.getEsAttachmentList();
            eventHub.$emit('loading', false);
          });
      },
      downloadSfEsAttachment(attachment_id, file_name) {
        let self = this;
        let url = self.$root.baseUrl + '/engineering-service/attachment/download/';
        let request_data = {
          user_name: self.loginUser,
          attachment_id: attachment_id,
          file_name: file_name
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params, responseType: 'arraybuffer' })
          .then((response) => {

            if (response.status === 200) {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              //console.log("file_name =" + file_name);
              link.setAttribute('download', file_name);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
              window.URL.revokeObjectURL(url);
            }
            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          })

      },
      lengthValidate() {
        let self = this;
        let validateColumnsMax255 = ['close_reason', 'tech_info.impact', 'tech_info.third_party_application', 'customization_info.eco_system'];
        let validateColumnsMax60 = ['sector_solution_info.user_group'];
        let validateColumns = ['tech_info.user_scenario', 'tech_info.configuration']; // MAX = 1000
        let validateColumnsMax2000 = ['tech_info.es_issue']; // MAX = 2000

        /* MAX = 60 */
        for (var i = 0; i < validateColumnsMax60.length; i++) {
          if (_.get(self.esTicketInfo, validateColumnsMax60[i], '') !== '' && _.get(self.esTicketInfo, validateColumnsMax60[i], '') !== null) {
            if (_.get(self.esTicketInfo, validateColumnsMax60[i], '').length > 60) {
              let text = `The max length of 60 characters in ${validateColumnsMax60[i]} is reached. You typed in ${_.get(self.esTicketInfo, validateColumnsMax60[i], '').length} characters`;
              self.$message.warning(text, 'Max Length Reached: User Group');
              return false;
            }
          }
        }

        /* MAX = 255 */
        for (var i = 0; i < validateColumnsMax255.length; i++) {
          if (_.get(self.esTicketInfo, validateColumnsMax255[i], '') !== '' && _.get(self.esTicketInfo, validateColumnsMax255[i], '') !== null) {
            if (_.get(self.esTicketInfo, validateColumnsMax255[i], '').length > 255) {
              let text = `The max length of 255 characters in ${validateColumnsMax255[i]} is reached. You typed in ${_.get(self.esTicketInfo, validateColumnsMax255[i], '').length} characters`;

              self.$message.warning(text, 'Max Length Reached');
              return false;
            }
          }
        }

        /* MAX = 300, 1000 */
        for (var i = 0; i < validateColumns.length; i++) {
          if (_.get(self.esTicketInfo, validateColumns[i], '') !== '' && _.get(self.esTicketInfo, validateColumns[i], '') !== null) {
            if (validateColumns[i] === 'tech_info.user_scenario' && _.get(self.esTicketInfo, validateColumns[i], '').length > 1000) {
              let text = `The max length of 1000 characters in Step 2 (user scenario or configuration) is reached. You typed in ${_.get(self.esTicketInfo, validateColumns[i], '').length} characters`;

              self.$message.warning(text, 'Max Length Reached in Step 2');
              return false;
            }
          }
        }

        //
        /* MAX = 2000 */
        for (var i = 0; i < validateColumnsMax2000.length; i++) {
          /*
          if (validateColumns[i] === 'tech_info.es_issue' && _.get(self.esTicketInfo, validateColumns[i], '').length > 2000) {
            let text = `The max length of 2000 characters in Engineering Service Issue / Requirement is reached. You typed in ${_.get(self.esTicketInfo, validateColumns[i], '').length} characters`;

            self.$message.warning(text, 'Max Length Reached: Engineering Service Issue');
            return false;
          }*/

          if (_.get(self.esTicketInfo, validateColumnsMax2000[i], '') !== '' && _.get(self.esTicketInfo, validateColumnsMax2000[i], '') !== null) {
            if (_.get(self.esTicketInfo, validateColumnsMax2000[i], '').length > 2000) {
              let text = `The max length of 2000 characters in ${validateColumnsMax2000[i]} is reached. You typed in ${_.get(self.esTicketInfo, validateColumnsMax2000[i], '').length} characters`;

              self.$message.warning(text, 'Max Length Reached');
              return false;
            }
          }
        }
        // !! ALL LOOP COMPLETED, PASS THE LENGTH VALIDATION !!
        return true;
      },
      basicCheckAutopilotInput(checkField) {
        let self = this;
        if (_.get(self.esTicketInfo.autopilot_info, checkField, null) === null
          || "None" === _.get(self.esTicketInfo.autopilot_info, checkField, null)
          || "" === _.get(self.esTicketInfo.autopilot_info, checkField, null)) {
          let text = `You are creating the customization type of ticket and has Autopilot request, please ensure you are input the required field: ${checkField}`;
          self.$message.warning(text, 'Requiring Fields for Customization/Autopilot');
          return false;
        }

        if ("tenant_domain" === checkField || "tenant_id" === checkField) {
          let format = /[ `!@#$%^&*()+\=\[\]{};':"\\|,<>\/?~]/;
          if (format.test(_.get(self.esTicketInfo.autopilot_info, checkField, ""))) {
            let text = `Invalid characters in the Autopilot required field: ${checkField}`;
            self.$message.warning(text, 'Invalid Characters in Requiring Fields');
            return false;
          }
        }

        if ("admin_email_val" === checkField) {
            // Use a safe, linear-time regex for email validation to prevent ReDoS
            let mailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            let text = _.get(self.esTicketInfo.autopilot_info, checkField, '');
            if (text.length > 254 || text.length == 0) return false;
            if (mailFormat.test(text) === false) {
              let warningText = `Invalid characters in the Autopilot required field: ${checkField}`;
              self.$message.warning(warningText, 'Invalid Characters in Requiring Fields');
              return false;
            }
        }
        return true;
      },

      validateCustomizationFieldsInput() {
        let self = this;
        if (self.esTicketInfo.ftie_id !== null) {
          // already transfer to ftie, ticket is ongoing
          return true;
        }
        else {
          /* if tyep is Customization
           * customization include 'ast to customize...' and 'Asks for a new Getac PN/BOM since it is not ready on eQuote yet.'
           * both of  'ast to customize...' and 'Asks for a new Getac PN/BOM...' need to tick autopilot
          */
          if (self.sfdc_request_type_mapping === 'Customization' || _.get(self.primaryInfoInputs, 'esPurpose', null) === 'Asks to customize existing Getac products for special items.' || _.get(self.primaryInfoInputs, 'esPurpose', null) === 'Asks for a new Getac PN/BOM since it is not ready on eQuote yet.') {
            // check autopilot tick if customization cases
            if (_.get(self.esTicketInfo, 'sa_selected_autopilot', null) === null || (_.get(self.esTicketInfo, 'sa_selected_autopilot', null) !== 'No' && _.get(self.esTicketInfo, 'sa_selected_autopilot', null) !== 'Yes')) {
              let text = `You are creating the customization type of ticket, please check if customer has request for Autopilot Registration`;
              self.$message.warning(text, 'Requiring Fields for Customization');
              return false;
            }
            // region: check autopilot required field
            if (self.ifHasAutopilotReq) {
              let checkAutopilotFields = ['tenant_id', 'tenant_domain', 'admin_email_val'];
              for (let i = 0; i < checkAutopilotFields.length; i++) {
                if (self.basicCheckAutopilotInput(checkAutopilotFields[i]) === false) {
                  return false;
                };
                /*
                 if (_.get(self.esTicketInfo.autopilot_info, checkAutopilotFields[i], null) === null
                  || "None" === _.get(self.esTicketInfo.autopilot_info, checkAutopilotFields[i], null)
                  || "" === _.get(self.esTicketInfo.autopilot_info, checkAutopilotFields[i], null)) {
                  let text = `You are creating the customization type of ticket and has Autopilot request, please ensure you are input the required field: ${checkAutopilotFields[i]}`;
                  self.$message.warning(text, 'Requiring Fields for Customization/Autopilot');
                  return false;
                }
                 */
              }
            } // end-region: check autopilot required field

            // region: check customization required info ['mp_delivery_date', 'customization_request']
            if (self.esTicketInfo.customization_info !== null) {
              let checkFields = ['mp_delivery_date', 'customization_request'];
              for (let i = 0; i < checkFields.length; i++) {
                if (_.get(self.esTicketInfo.customization_info, checkFields[i], null) === null
                  || "None" === _.get(self.esTicketInfo.customization_info, checkFields[i], null)
                  || "" === _.get(self.esTicketInfo.customization_info, checkFields[i], null)) {
                  let text = `You are creating the customization type of ticket, please ensure you are input the required field: ${checkFields[i]}`;
                  self.$message.warning(text, 'Requiring Fields for Customization');
                  return false;
                }
              }
              return true; // finish checking ['mp_delivery_date', 'customization_request'] in customization fields
            } else {
              let text = `You are creating the customization type of ticket, please ensure you are input the required fields in Customization Info Section`;
              self.$message.warning(text, 'Requiring Fields for Customization');
              return false;
            } // end-region: check customization required info
          } else {
            // non customization type of ticket
            //console.log("non customization type of ticket, instead, the type is:");
            //console.log(self.sfdc_request_type_mapping);
            return true;
          }
        }
      },

      validate() {
        let self = this;
        let validate_columns = ['rsm', 'accountId', 'esPurpose', 'typeOfIssue', 'requirementStage']
        let validate_empty = true;
        for (var i = 0; i < validate_columns.length; i++) {
          if (self.primaryInfoInputs[validate_columns[i]] == null) {
            validate_empty = false;
            break;
          }
        }
        if (self.esTicketInfo.tech_info.priority === null) {
          self.$message.warning('Please maintain the Priority fields in step 2!', 'Column Required Remind');
          validate_empty = false;
        }

        if (!validate_empty || self.esTicketInfo.tech_info.model === null) {
          self.$message.warning('Please ensure that you input all the required columns!', 'Column Required Remind');
          validate_empty = false;
        }

        return validate_empty;
      },
      postEsExistFtieData() {
        let self = this;
        let autopilot_info_change_flag = false;

        if (_.get(self.esTicketInfo, 'sa_selected_autopilot', null) !== _.get(self.esTicketOriginalInfo, 'sa_selected_autopilot', null)) {
          autopilot_info_change_flag = true
        }

        if (JSON.stringify(self.esTicketInfo.autopilot_info) !== JSON.stringify(self.esTicketOriginalInfo.autopilot_info)) {
          autopilot_info_change_flag = true
        }
        let requestData = {
          input_info: JSON.parse(JSON.stringify(self.esTicketInfo)),
          original_tag_sa_selected_autopilot: _.get(self.esTicketOriginalInfo, 'sa_selected_autopilot', null),
          username: self.loginUser,
          autopilot_info_change_flag: autopilot_info_change_flag,
          original_autopilot_info: self.esTicketOriginalInfo.autopilot_info
        }
        self.searching = true;
        eventHub.$emit('loading', true);
        this.$axios
          .post(self.$root.baseUrl + '/engineering-service/partial-save/', requestData)
          .then(res => {
            let result = res.data;
            if (_.get(result, 'save_success', false)) {
              console.log("result.save_success::");
              console.log(_.get(result, 'save_success', false));
              self.updateFailedNotification = null;
              self.updateSuccessNotification = "The engineering service has been updated successfully!";
            } else {
              let erroMsg = '';
              self.updateSuccessNotification = null;
              self.updateFailedNotification = "Update engineering service failed!";
            }
          })
          .finally(() => {
            self.searching = false;
            eventHub.$emit('loading', false);
            self.getPage();
          });
      },
      partialSaveValidate() {
        let self = this;
        let validate_empty = true;
        if (self.esTicketInfo.es_ticket_status === 'Close') {
          if (_.get(self.esTicketInfo, 'close_reason', '') === '' || _.get(self.esTicketInfo, 'close_reason', null) === null) {
            validate_empty = false;
            self.$message.warning('Please input the close reason!', 'Close Reason required');
            return false;
          } else {
            if (_.get(self.esTicketInfo, 'close_reason', '').length > 255) {
              let text = `The max length of 255 characters in Close Reason is reached. You typed in ${_.get(self.esTicketInfo, 'close_reason', '').length} characters`;
              self.$message.warning(text, 'Max Length Reached: Close Reason');
              return false;
            }
          }
        } else {
          // Not a close ticket
          if (self.ifHasAutopilotReq) {
            let checkAutopilotFields = ['tenant_id', 'tenant_domain', 'admin_email_val'];
            for (let i = 0; i < checkAutopilotFields.length; i++) {
              if (self.basicCheckAutopilotInput(checkAutopilotFields[i]) === false) {
                return false;
              };
              /*
               if (_.get(self.esTicketInfo.autopilot_info, checkAutopilotFields[i], null) === null
                || "None" === _.get(self.esTicketInfo.autopilot_info, checkAutopilotFields[i], null)
                || "" === _.get(self.esTicketInfo.autopilot_info, checkAutopilotFields[i], null)) {
                let text = `You are creating the customization type of ticket and has Autopilot request, please ensure you are input the required field: ${checkAutopilotFields[i]}`;
                self.$message.warning(text, 'Requiring Fields for Customization/Autopilot');
                return false;
              }
               */
            }
          }
        }


        /*
         if (self.esTicketInfo.es_ticket_status === 'Close' && !self.esTicketInfo.close_reason) {
          validate_empty = false;
          self.$message.warning('Please input the close reason!', 'Close Reason required');
          return false;
        }
         */
        return validate_empty;
       },
      /**
  // might switch this function to FTIE object,
  // better have the Region info, and allow region SA head to transfer L1 owner
      checkRegionSAHead() {
        let self = this;
        // self.$session.get('user_site'), self.loginUser
        // region
        // function or roles recording the sa head
      },
      */

      checkSaveButtonDisabled() {
        let defaultGmlSaMembers = ['tongyi.xu', 'koko.wu', 'xianglong.li', 'tracy.lu', 'bor.tsang'];
        if ((this.userRoles && _.indexOf(this.userRoles, 'Admin') > -1)
          || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM') > -1)
          || (this.userRoles && _.indexOf(this.userRoles, 'ES_PM_Leader') > -1)
          || (this.userFunctions && _.indexOf(this.userFunctions, 'ES PM Leader') > -1)
          || (this.esTicketInfo != null && this.loginUser === this.esTicketInfo.es_ticket_create_by)
          || (this.esTicketInfo != null
            && this.loginUser !== null
            && this.esTicketInfo.es_ticket_create_by !== null
            && this.loginUser.replaceAll(".", " ").toUpperCase() === this.esTicketInfo.es_ticket_create_by.toUpperCase()) //text.replace(".", " ").toUpperCase();;
          || (this.esTicketInfo.es_ticket_create_by == 'gmlsa.gml' && defaultGmlSaMembers.includes(this.loginUser)))
        {
          return false;
        } else {
          return true;
        }
      },
      checkAssignerPermission() {
        let self = this;
        if (self.userRoles.includes('ASSIGNER') || self.userRoles.includes('Admin')) {
          return true
        }
        return false;
      },
      showChangeOwnerModal() {
        let self = this;
        if (self.checkAllDataSaved('Change Owner')) {
          self.get_gro_owner_list();
          self.$refs['ChangeOwnerModal'].show();
          self.tranfer_to_owner = self.esTicketInfo.es_ticket_create_by;
        }
      },
      showCloneEsModal() {
        let self = this;
        if (self.checkAllDataSaved('Clone ES')) {
          if (null === _.get(self.esTicketInfo, 'primary_info.es_purpose', null)
            || null === _.get(self.esTicketInfo, 'primary_info.matching_issue', null)
            || null === _.get(self.esTicketInfo, 'primary_info.requirement_stage', null)) {
            self.$refs['UnableToClone'].show();
          } else {
            self.$refs['CloneEsModal'].show();
          }
        }

      },
      doCloneES(bvModalEvt) {
        console.log("doCloneES START!");
        let self = this;
        let defaultGmlSaMembers = ['tongyi.xu', 'koko.wu', 'xianglong.li', 'tracy.lu', 'bor.tsang']
        let create_by = self.loginUser;
        if (defaultGmlSaMembers.includes(self.login_user_name)) {
          create_by = 'gmlsa.gml';
        }
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/engineering-service/clone/';
        let request_data = {
          input_info: JSON.parse(JSON.stringify(self.esTicketInfo)),
          site: self.$session.get('user_site'),
          request_detail_id: self.esTicketInfo.request_detail_id,
          owner_id: self.esTicketInfo.owner_id,
          owner_name: self.esTicketInfo.es_ticket_create_by,
          create_by: create_by,
          //create_by: self.esTicketInfo.create_by,
          ftie_id: self.esTicketInfo.ftie_id,
          es_id_in_opty_obj: self.esTicketInfo.opty_obj_id,
          action: 'clone',
        };
        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        let save_success = false;
        let es_id = null;
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
              //save_success = _.get(res, 'save_success', false);
              es_id = res.es_id;
            }
            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success && es_id !== null) {
              window.location.href = self.frontEndUrlToUse + 'engineering-service/opty-id/' + es_id;
            }
          })
        self.$nextTick(() => {
          self.$refs['CloneEsModal'].hide();
        })
      },

      doChangeOwner(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/engineering-service/change-es-owner/';

        let request_data = {
          request_detail_id: self.esTicketInfo.request_detail_id,
          owner_id: self.esTicketInfo.owner_id,
          owner_name: self.esTicketInfo.es_ticket_create_by,
          new_owner: self.tranfer_to_owner,
          login_user_name: self.loginUser,
          ftie_id: self.esTicketInfo.ftie_id,
          es_id_in_opty_obj: self.esTicketInfo.opty_obj_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              window.location.href = self.frontEndUrlToUse + 'engineering-service/opty-id/' + self.esTicketInfo.opty_obj_id;
            }
          })
        self.$nextTick(() => {
          self.$refs['ChangeOwnerModal'].hide();
        })
      },
      showAssignTicketModal() {
        let self = this;
        self.$refs['AssignTicketModal'].show()
        self.assigned_ticket_owner = self.esTicketInfo.gtc_owner;
      },
      assignTicket(bvModalEvt) {
        let self = this;
        bvModalEvt.preventDefault();
        let url = self.$root.baseUrl + '/ftie/reassign-ticket/';

        let request_data = {
          request_detail_id: self.esTicketInfo.request_detail_id,
          assigned_ticket_owner: self.assigned_ticket_owner,
          login_user_name: self.loginUser,
          ftie_id: self.esTicketInfo.ftie_id
        };

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let save_success = false;
        self.$axios.post(url, request_data, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              save_success = JSON.parse(res['save_success']);
            }
            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
            if (save_success) {
              window.location.href = self.frontEndUrlToUse + 'engineering-service/opty-id/' + self.esTicketInfo.opty_obj_id;
            }
          })
        self.$nextTick(() => {
          self.$refs['AssignTicketModal'].hide();
        })
      },
      get_gro_owner_list() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-sa-list-by-owner-site/';
        let originalCreateBy = _.get(self.esTicketInfo, 'es_ticket_create_by', null);//es_ticket_create_by
        let request_data = {
          original_create_by: originalCreateBy,
        };
        let gro_owner_list = [];
        eventHub.$emit('loading', true);
        self.$axios.post(url, request_data)
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              gro_owner_list = JSON.parse(res['gro_owner_list']);
              self.GROOwnerList = JSON.parse(res['gro_owner_list']);
              // self.GROOwnerList.unshift('ALL');
            }
            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      get_ftie_gtc_owner_list() {
        let self = this;
        let url = self.$root.baseUrl + '/ftie/get-ftie-owners';

        const params = {
          token: encodeURI(self.$store.state.token),
          username: encodeURI(self.$store.state.username),
        };
        eventHub.$emit('loading', true);
        let gtc_owner_list = [];
        self.$axios.get(url, { params })
          .then((response) => {
            var res = response.data;
            //console.log(res);

            if (response.status === 200) {
              self.GTCOwnerList = JSON.parse(res['gtc_owner_list']);
              self.GTCOwnerList.unshift('ALL');
            }
            else if (res.description === "login" || res.description === "Your session has expired due to inactivity in a specific time. Please log in again to continue.") {
              self.$session.destroy();
              self.$store.commit('clearToken');
              var url = self.$root.baseUrl + '/auth/logout/';
              self.$axios.get(url)
                .then((res) => {
                  console.log('logout');
                  self.$router.push("/");
                })
              window.location = self.frontEndUrlToUse + 'azure-login';
            } else {
              self.$message.exception('Internal Server Error!');
              console.log(res.description);
              //console.log(res['msg'])
            }
          }, (error) => {
            console.log(error);
            self.$message.exception('Internal Server Error!');
          })
          .finally(() => {
            eventHub.$emit('loading', false);
          });
      },
      checkAllDataSaved(actionName) {
        let self = this;
        if (self.userEditable) {
          let text = `It looks like you have been editing something. If you click ${actionName} before saving, your changes will be lost.`;
          self.$message.error(text, 'Unsaved Changes');
          return false;
        }
        return true;
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/engineering-service-process/EngineeringServicePageByOptyId.vue